<!-- Content -->
<div #contentDiv class="bg-theme-surface-95 backdrop-blur-2xl max-w-lg md:max-w-6xl mx-auto min-h-[calc(100vh)] text-theme-text">
  <div class="pb-[calc(9rem+env(safe-area-inset-bottom))]">
    <div *ngIf="topImage" class="mb-2 md:px-0 md:pt-0">
      <img class="w-full object-cover h-56 rounded-b-3xl md:h-72 lg:h-96 md:rounded-none"
           src="https://storage.googleapis.com/heynow/danilo/place-holder.gif" [appHires]="topImage">
    </div>
    <div *ngIf="!topImage" class="h-20"></div>
    <div class="p-3">
      <div class="mr-3 flex items-center">
        <app-circle-button icon="fa-chevron-left" size="8" type="solid" fontSize="sm" (onClick)="back()"></app-circle-button>
        <span class="text-lg text-theme-text font-bold ps-2" *ngIf="section">{{getPageName(pageId)}}</span>
        <span class="text-lg text-theme-text font-bold px-1" *ngIf="section">›</span>
        <span class="text-lg text-theme-text font-normal pe-2" *ngIf="section">{{ section.name }}</span>
      </div>
      <div *ngIf="categories && categories.length>0; else noCats">
        <div *ngFor="let category of categories">
          <!-- Category header spans full width -->
          <div class="text-3xl/5 text-theme-text1 font-bold px-4 pt-8 font-custom" [style]="themeService.customFontStyle">{{ category.name }}</div>
          <div *ngIf="category.desc" class="text-lg px-4 text-theme-text3 pt-2 font-regular">{{ category.desc }}</div>
          <div class="border-b mt-4 border-theme-divider"></div>
          <!-- Grid for items within the category -->
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div *ngFor="let item of category.items" class="px-4 py-6">
              <app-menu-item [item]="item" [count]="item.currentOrderCount" [outOfStock]="item.currentStockState" (onClick)="displayItem(item)" [showWhen]="showWhen"></app-menu-item>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noCats>
        <div *ngIf="loading" class="pt-24">
          <app-loading-spinner size="lg"></app-loading-spinner>
        </div>
        <div *ngIf="!loading" class="text-theme-text text-center pt-24 text-2xl">
           {{getString("Oj, här fanns inga artiklar att visa")}}
        </div>
      </ng-template>
    </div>
  </div>
</div>

<app-order-page-nav [selectedPageId]="pageId || ''"></app-order-page-nav>
